import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { DocumentsResponce } from 'services/requests';
import { ApiError } from 'services/api.errors';
import { QueryKeys } from 'constants/queryKeys';

export const useGetDocuments = () => {
  const queryKey = QueryKeys.documents;
  const queryFn = async () => {
    const { data } = await api.getDocuments();
    return data;
  };

  return useQuery<DocumentsResponce, AxiosError<ApiError>>(queryKey, queryFn, {
    refetchOnWindowFocus: false,
  });
};
